<div>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Bootstrap Modal</h4>
        <button type="button" class="close" aria-label="Close" >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        This is example from ItSolutionStuff.com
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" >Ok</button>
      </div>
</div>
